import type { ReactNode } from 'react'

interface GeneralAgentHeaderButtonProps {
    label: string
    onClick: () => void
    disabled?: boolean
    children: ReactNode
}

/** A small icon button in the chat's header (new chat, expand, minimize, close). */
export const GeneralAgentHeaderButton = ({ label, onClick, disabled, children }: GeneralAgentHeaderButtonProps) => (
    <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={label}
        title={label}
        className="rounded-full p-1.5 text-foreground-muted transition-colors duration-150 hover:bg-default hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent disabled:cursor-not-allowed disabled:opacity-50"
    >
        {children}
    </button>
)
